import {defineStore} from 'pinia'
import {ref, computed} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useItemDataStore} from '@/stores/itemData'

export const useStateHistoryStore = defineStore('stateHistory', () => {
    // Initialized directly from localStorage
    const historyItems = ref(JSON.parse(localStorage.getItem('stateHistory') || '[]'))
    
    // Getter returning history items
    const items = computed(() => historyItems.value)
    
    function setData(data) {
        let array = [...historyItems.value]
        
        // Remove duplicate paths
        array = array.filter((obj) => obj.fullPath !== data.fullPath)
        
        // We want the most recent activity first
        array.unshift(data)
        
        // Reduce the history down to only 10 items
        while (array.length > 10) {
            array.pop()
        }
        
        // Update state and localStorage
        historyItems.value = array
        localStorage.setItem('stateHistory', JSON.stringify(array))
    }
    
    async function set({stateName, tableName, id, fullPath}) {
        let data = {fullPath}
        
        if (stateName === 'form') {
            // Skip the specified tables
            const tableNames = ['modules_filters']
            if (tableNames.includes(tableName)) {
                return false
            }
            
            data.key = document.location.pathname
            
            const componentsStore = useComponentsStore()
            const itemDataStore = useItemDataStore()
            const component = componentsStore.items.find((o) => o.tableName === tableName)
            
            if (!component) {
                return
            }
            
            data.componentTitle = component.title
            
            if (id) {
                const obj = await itemDataStore.get({
                    tableName: tableName,
                    id: id
                })
                
                if (obj) {
                    const nameField = componentsStore.nameField(component.id)
                    
                    let title = obj[nameField]
                    if (title) {
                        data.itemTitle = title
                    }
                    
                    setData(data)
                } else {
                    // Store listing history state only if query parameters are in use
                    let href = document.location.href
                    let path = document.location.pathname
                    if (href !== path) {
                        setData(data)
                    }
                }
            }
        }
    }
    
    return {
        items,
        set,
        setData
    }
})